'use strict';

module.exports = {
    recipientPickingDisabled: 'recipient.picking.disabled',
    endpointNoDevice: 'endpoint.noDevice',
    endpointMissingDeviceConnectivity: 'endpoint.device.missingConnectivity',
    endpointDeviceNotConnected: 'endpoint.device.notConnected',
    endpointDeviceNotActivated: 'endpoint.device.notActivated',
    jobNotFound: 'job.notFound',
    endpointMissingRelayConnectivity: 'endpoint.relay.missingConnectivity',
    endpointRelayNotConnected: 'endpoint.relay.notConnected',
    endpointRelayNotActivated: 'endpoint.relay.notActivated',
    partnerEndpointWarning: 'partnerEndpoint.warning',
    partnerEndpointError: 'partnerEndpoint.error',
    gcpHmacKeyLimitReached: 'gcp.hmacKey.limit.reached'
};